module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n      <pioneer-add-rsvp *pioneerAuthorize=\"{permission: 'AddRsvp'}\"\n                        [event]=\"onyxEvent\">\n      </pioneer-add-rsvp>\n      <pioneer-rsvp-list [event]=\"onyxEvent\"></pioneer-rsvp-list>\n    </div>\n    <pioneer-event-nav></pioneer-event-nav>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/rsvp/rsvp.component.html
// module id = kD7v
// module chunks = 0